import {axiosGetHandler, axiosPostHandler} from './config'
import {extractAPIValues} from '_lib/utils/utils'
const {BASE_API} = extractAPIValues()

export async function getUpdateUrl (args) {
  let url = BASE_API + '/chatroom/v2/settings/version/update/check'
  if (!args) { 
    args = {}
  }
  if (window.exe_bit) {
    args.bit = window.exe_bit
  }
  if (window.windows_version) {
    args.windows_version = window.windows_version
  } else {
    try {
      if (navigator.userAgentData) {
        let ua = await navigator.userAgentData.getHighEntropyValues(["platformVersion"])
        if (navigator.userAgentData.platform === "Windows") {
          const majorPlatformVersion = parseInt(ua.platformVersion.split('.')[0]);
          args.windows_version = majorPlatformVersion
        }
      }
    } catch(e) {console.error(e);}
  }
	return axiosGetHandler(url, args)
}

export async function getCurrentVersionLog (args) {
  let url = BASE_API + '/chatroom/v2/settings/version/content'

  if (window.exe_bit) {
    args.bit = window.exe_bit
  }
  if (window.windows_version) {
    args.windows_version = window.windows_version
  } else {
    try {
      if (navigator.userAgentData) {
        let ua = await navigator.userAgentData.getHighEntropyValues(["platformVersion"])
        if (navigator.userAgentData.platform === "Windows") {
          const majorPlatformVersion = parseInt(ua.platformVersion.split('.')[0]);
          args.windows_version = majorPlatformVersion
        }
      }
    } catch(e) {console.error(e);}
  }
	return axiosGetHandler(url, args)
}